// this needs to be in separate file, because it's used in .vite.config.js
export const LANGUAGES = {
	WOLTAIR_CZ: 'cs',
	WOLTAIR_PL: 'pl',
	WOLTAIR_DE: 'de',
	WOLTAIR_IT: 'it'
}
